import React, { Component } from "react";

// STYLES
import styled from "styled-components";
import Colors from "../../shared/colors";

// PLAYER
import ReactPlayer from "react-player";

// ANIMATION
import { Animated } from "react-animated-css";

// ICONS
import FaClose from "react-icons/lib/fa/close";

export default class Videos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      urls: this.props.urls,
      value: "",
      error: false,
      message: "",
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      urls: nextProps.urls,
    });
  }

  updateValue = (event) => {
    let urls = this.state.urls;

    const value = event.target.value;

    if (value !== "") {
      urls.push({
        url: value,
        error: false,
        ready: false,
      });

      this.setState({
        urls: urls,
      });
    }
    this.setState({
      value: event.target.value,
      error: false,
      message: "",
    });
  };

  // getValue = () => {
  //   let urls = this.state.urls;
  //   const value = this.state.value;

  //   if (value !== "") {
  //     urls.push({
  //       url: value,
  //       error: false,
  //       ready: false,
  //     });

  //     this.setState({
  //       urls: urls,
  //     });
  //   }
  // };

  removeUrl = (id) => {
    let urls = this.state.urls;

    urls.splice(id, 1);

    this.props.getValuesUrls(urls);

    this.setState({
      urls: urls,
    });
  };

  onReadyUrl = (event, index) => {
    let urls = this.state.urls;

    urls[index].ready = true;

    this.props.getValuesUrls(urls);

    this.setState({
      urls: urls,
      value: "",
    });
  };

  onErrorUrl = (event, index) => {
    this.setState(
      {
        error: true,
        message: "Url inválido",
      },
      () => {
        let urls = this.state.urls;

        urls.splice(index, 1);

        setTimeout(() => {
          this.setState({
            urls: urls,
          });
        }, 3000);
      }
    );
  };

  render() {
    const { title, placeholder } = this.props;

    const { urls, error, message, value } = this.state;

    return (
      <Content>
        <Title>{title}</Title>
        <InputContent>
          <input
            type="text"
            value={value}
            placeholder={placeholder}
            onChange={this.updateValue}
          />
        </InputContent>
        {error && <Error>{message}</Error>}
        <Animated
          animationIn="fadeIn"
          animationOut="fadeOut"
          isVisible={urls.length > 0 ? true : false}
        >
          <VideosContent>
            {urls.map((url, index) => {
              return (
                <Video key={index}>
                  <ReactPlayer
                    width="100%"
                    height="120px"
                    url={url.url}
                    onReady={(event, _index) => this.onReadyUrl(event, index)}
                    onError={(event, _index) => this.onErrorUrl(event, index)}
                    youtubeConfig={{ playerVars: { showinfo: 1 } }}
                    facebookConfig={{ appId: "394229507688313" }}
                  />
                  <Remove onClick={(id) => this.removeUrl(index)}>
                    <FaClose />
                  </Remove>
                </Video>
              );
            })}
          </VideosContent>
        </Animated>
      </Content>
    );
  }
}

const Content = styled.div`
  margin-bottom: 5px;
`;
const Title = styled.div`
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  margin-bottom: 8px;

  span {
    font-weight: 400;
  }
`;
const InputContent = styled.div`
  display: flex;

  input {
    width: calc(100% - 16px);
    color: #545454;
    font-family: "PT Sans";
    font-size: 14px;
    line-height: 18px;
    padding: 10px 8px;
    border-radius: 3px;
    border: 1px solid #e6ebec;
    outline: none;
    margin-bottom: 3px;
    transition: all 0.3s ease;

    &:focus {
      border: 1px solid ${Colors.primary};
    }
  }
`;
const VideosContent = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin-top: 10px;
  margin-left: -5px;
  margin-right: -5px;
`;
const Video = styled.div`
  width: calc(33.3% - 30px);
  position: relative;
  margin: 5px;
  padding: 10px;
  box-shadow: 0 2px 6px 0 hsla(0, 0%, 0%, 0.15);
  border-radius: 3px;
  margin-bottom: 5px;

  @media screen and (max-width: 767px) {
    width: calc(33.3% - 30px);
  }
  @media screen and (max-width: 560px) {
    width: calc(50% - 30px);
  }
  @media screen and (max-width: 460px) {
    width: 100%;
  }
`;
const Remove = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50px;
  background-color: #fff;
  position: absolute;
  top: -5px;
  right: -6px;
  z-index: 50;
  text-align: center;
  line-height: 27px;
  box-shadow: 0 2px 6px 0 hsla(0, 0%, 0%, 0.15);
  color: hsl(0, 0%, 17%);
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    color: ${Colors.primary};
  }
`;
const Error = styled.div`
  font-family: "PT Sans";
  font-size: 13px;
  color: red;
  opacity: 0.8;
  margin-top: 5px;
`;



// WEBPACK FOOTER //
// ./src/components/videos/videos.js